import { Component, OnInit } from '@angular/core';
import { VerificationService } from '../../services/verification/verification.service';
import { TranslationsService } from '../../services/translations/translations.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  username = '';
  password = '';
  token = '';

  notLinked = false;
  language = '';

  constructor(
    private readonly verificationService: VerificationService,
    private readonly translationsService: TranslationsService
  ) {}

  ngOnInit(): void {
    this.language = this.translationsService.getCurrentLanguage();
    this.notLinked = !this.verificationService.isLinked();
    if (this.notLinked) {
      this.username = this.verificationService.getUsername();
      this.token = this.verificationService.getToken();
      this.password = this.verificationService.getPassword();
    }
  }
}
